module.exports = __webpack_public_path__ + "img/banner1.5e5286f9.png";